// extracted by mini-css-extract-plugin
export default {"button":"Button_button__+ymec","button-default":"Button_button-default__Yj6be","button-primary":"Button_button-primary__uDcqQ"};